import Swiper from 'swiper';
import {Pagination, Navigation, Autoplay, Thumbs, EffectFade, EffectCreative} from 'swiper/modules';

const initSliders = () => {
    const initHeroSlider = () => {

        const heroThumbsSwiper = new Swiper('.swiper--hero-thumbs', {
            modules: [ Navigation, Autoplay ],
            navigation: {
                nextEl: '.swiper--hero-thumbs-button-next',
                prevEl: '.swiper--hero-thumbs-button-prev',
            },
            spaceBetween: 24,
            slidesPerView: "auto",
            watchSlidesProgress: true,
        });

        const heroSwiper = new Swiper('.swiper--hero', {
            modules: [ Navigation, EffectFade, Thumbs, Autoplay ],
            effect: "fade",
            watchOverflow: true,
            slidesPerView: 1,
            spaceBetween: 0,
            navigation: {
                nextEl: '.swiper--hero-button-next',
                prevEl: '.swiper--hero-button-prev',
                addIcons: false,
            },
            watchSlidesProgress: true,
            thumbs: {
                swiper: heroThumbsSwiper,
            },
            loop: true,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false
            },
            on: {
                autoplayTimeLeft(swiper, time, progress) {
                    const progressBarElms = document.querySelectorAll('.swiper--hero-thumbs .progress__bar');
                    progressBarElms.forEach((bar) => {
                        bar.style.width = '0%';
                        bar.classList.remove('animate');
                    });
                    const progressPercent = 100 - Math.round(progress * 100);
                    const activeThumbSlide = heroThumbsSwiper.el.querySelector('.swiper-slide-thumb-active');
                    const progressBar = activeThumbSlide.querySelector('.progress__bar');
                    if (progressBar) {
                        progressBar.classList.add('animate');
                        progressBar.style.width = progressPercent + '%';
                    }
                }
            }

        });

    };

    const initFeaturesSlider = () => {
        const featuresSwiper = new Swiper('.swiper--features', {
            modules: [ Pagination ],
            pagination: {
                el: '.swiper--features-pagination',
                clickable: true,
                dynamicBullets: true,
                // type: "fraction",
                // formatFractionCurrent: (number) => number < 10 ? '0' + number : number,
                // formatFractionTotal: (number) => number < 10 ? '0' + number : number,
            },
            watchOverflow: true,
            slidesPerView: 1,
            spaceBetween: 16,
            // simulateTouch: false,
            breakpoints: {
                768: {
                    slidesPerView: 2,
                    // freeMode: true,
                },
                1024: {
                    slidesPerView: 3,
                },
                1280: {
                    slidesPerView: 4,
                    spaceBetween: 0,
                },
            },
        });
        // return filmsSwiper;
    };

    const initHomeProductsSlider = () => {
        const productsSwiper = new Swiper('.swiper--products', {
            modules: [ Navigation, Pagination ],
            pagination: {
                el: '.swiper--products-pagination',
                clickable: true,
                dynamicBullets: true,
            },
            navigation: {
                nextEl: '.swiper--products-button-next',
                prevEl: '.swiper--products-button-prev',
            },
            watchOverflow: true,
            slidesPerView: 1,
            spaceBetween: 16,
            // simulateTouch: false,
            breakpoints: {
                640: {
                    slidesPerView: 2,
                    slidesPerGroup: 2,
                    spaceBetween: 16,
                    // freeMode: true,
                    pagination: {
                        el: '.swiper--products-pagination',
                        clickable: true,
                        dynamicBullets: true,
                    },
                },
                1024: {
                    slidesPerView: 3,
                    slidesPerGroup: 3,
                    spaceBetween: 0,
                    pagination: {
                        el: '.swiper--products-pagination',
                        clickable: true,
                        dynamicBullets: false,
                    },
                },
                1280: {
                    slidesPerView: 4,
                    spaceBetween: 0,
                    slidesPerGroup: 4,
                    pagination: {
                        el: '.swiper--products-pagination',
                        clickable: true,
                        dynamicBullets: false,
                    },
                },
            },
        });
        // console.log('productsSwiper', productsSwiper);
        // return filmsSwiper;
    };

    const initArticlesSlider = () => {
        const articlesSwiper = new Swiper('.swiper--articles', {
            modules: [ Navigation, Pagination ],
            pagination: {
                el: '.swiper--articles-pagination',
                clickable: true,
                dynamicBullets: true,
            },
            navigation: {
                nextEl: '.swiper--articles-button-next',
                prevEl: '.swiper--articles-button-prev',
            },
            watchOverflow: true,
            slidesPerView: 1,
            spaceBetween: 16,
            simulateTouch: false,
            breakpoints: {
                640: {
                    slidesPerView: 2,
                    slidesPerGroup: 2,
                    spaceBetween: 16,
                    // freeMode: true,
                    pagination: {
                        el: '.swiper--articles-pagination',
                        clickable: true,
                        dynamicBullets: true,
                    },
                },
                1024: {
                    slidesPerView: 3,
                    slidesPerGroup: 3,
                    spaceBetween: 24,
                    pagination: {
                        el: '.swiper--articles-pagination',
                        clickable: true,
                        dynamicBullets: false,
                    },
                },
                // 1280: {
                //     slidesPerView: 4,
                //     spaceBetween: 0,
                //     slidesPerGroup: 4,
                //     pagination: {
                //         el: '.swiper--articles-pagination',
                //         clickable: true,
                //         dynamicBullets: false,
                //     },
                // },
            },
        });
        // console.log('productsSwiper', productsSwiper);
        // return filmsSwiper;
    };

    const initPhotosSlider = () => {
        const photosSwiper = new Swiper('.swiper--photos', {
            modules: [ Navigation, Pagination ],
            pagination: {
                el: '.swiper--photos-pagination',
                clickable: true,
                dynamicBullets: true,
            },
            navigation: {
                nextEl: '.swiper--photos-button-next',
                prevEl: '.swiper--photos-button-prev',
            },
            watchOverflow: true,
            slidesPerView: 2,
            slidesPerGroup: 2,
            spaceBetween: 16,
            // simulateTouch: false,
            breakpoints: {
                640: {
                    slidesPerView: 3,
                    slidesPerGroup: 3,
                    spaceBetween: 16,
                    freeMode: true,
                    pagination: {
                        el: '.swiper--photos-pagination',
                        clickable: true,
                        dynamicBullets: true,
                    },
                },
                1024: {
                    slidesPerView: 4,
                    slidesPerGroup: 4,
                    spaceBetween: 24,
                    pagination: {
                        el: '.swiper--photos-pagination',
                        clickable: true,
                        dynamicBullets: false,
                    },
                },
                1280: {
                    slidesPerView: 5,
                    slidesPerGroup: 5,
                    spaceBetween: 24,
                    pagination: {
                        el: '.swiper--photos-pagination',
                        clickable: true,
                        dynamicBullets: false,
                    },
                },
                1440: {
                    slidesPerView: 6,
                    slidesPerGroup: 6,
                    spaceBetween: 24,
                    pagination: {
                        el: '.swiper--photos-pagination',
                        clickable: true,
                        dynamicBullets: false,
                    },
                },
            },
        });
        // console.log('productsSwiper', productsSwiper);
        // return filmsSwiper;
    };

    const initVideosSlider = () => {
        const videosSwiper = new Swiper('.swiper--videos', {
            modules: [ Navigation, Pagination ],
            pagination: {
                el: '.swiper--videos-pagination',
                clickable: true,
                dynamicBullets: true,
            },
            navigation: {
                nextEl: '.swiper--videos-button-next',
                prevEl: '.swiper--videos-button-prev',
            },
            watchOverflow: true,
            slidesPerView: 1,
            spaceBetween: 16,
            simulateTouch: false,
            breakpoints: {
                640: {
                    slidesPerView: 2,
                    slidesPerGroup: 2,
                    spaceBetween: 16,
                    // freeMode: true,
                    pagination: {
                        el: '.swiper--videos-pagination',
                        clickable: true,
                        dynamicBullets: true,
                    },
                },
                1024: {
                    slidesPerView: 3,
                    slidesPerGroup: 3,
                    spaceBetween: 24,
                    pagination: {
                        el: '.swiper--videos-pagination',
                        clickable: true,
                        dynamicBullets: false,
                    },
                },
                // 1280: {
                //     slidesPerView: 4,
                //     spaceBetween: 0,
                //     slidesPerGroup: 4,
                //     pagination: {
                //         el: '.swiper--articles-pagination',
                //         clickable: true,
                //         dynamicBullets: false,
                //     },
                // },
            },
        });
        // console.log('productsSwiper', productsSwiper);
        // return filmsSwiper;
    };

    const initTestimonialsSlider = () => {

        const testimonialsThumbsSwiper = new Swiper('.swiper--testimonials-thumbs', {
            modules: [ Navigation, Autoplay, EffectCreative ],
            // navigation: {
            //     nextEl: '.swiper--hero-thumbs-button-next',
            //     prevEl: '.swiper--hero-thumbs-button-prev',
            // },
            spaceBetween: 24,
            slidesPerView: 1,
            watchSlidesProgress: true,
            effect: "creative",
            // simulateTouch: false,
            creativeEffect: {
                prev: {
                    // shadow: true,
                    translate: [0, 0, -1],
                },
                next: {
                    translate: ["-100%", 0, 0],
                },
            },
        });

        const testimonialsSwiper = new Swiper('.swiper--testimonials', {
            modules: [ Pagination, EffectFade, Thumbs, Autoplay ],
            effect: "fade",
            watchOverflow: true,
            slidesPerView: 1,
            spaceBetween: 0,
            speed: 600,
            // simulateTouch: false,
            pagination: {
                el: '.swiper--testimonials-pagination',
                clickable: true,
                // dynamicBullets: true,
            },
            watchSlidesProgress: true,
            thumbs: {
                swiper: testimonialsThumbsSwiper,
            },
            loop: true,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false
            },
            // on: {
            //     autoplayTimeLeft(swiper, time, progress) {
            //         //swiper curent slide index
            //         console.log(swiper.realIndex);
            //     }
            // }

        });

        // setInterval(() => {
        //     testimonialsSwiper.slideNext(600); // всегда вперёд
        // }, 5000);

    };

    const initModalProductSlider = () => {

        const modalProductThumbsSwiper = new Swiper('.swiper--modal-product-image-thumbs', {
            // modules: [ Navigation ],
            // navigation: {
            //     nextEl: '.swiper--hero-thumbs-button-next',
            //     prevEl: '.swiper--hero-thumbs-button-prev',
            // },
            spaceBetween: 16,
            slidesPerView: "auto",
            watchSlidesProgress: true,
        });

        const modalProductSwiper = new Swiper('.swiper--modal-product-image', {
            modules: [ Thumbs ],
            watchOverflow: true,
            slidesPerView: 1,
            spaceBetween: 0,
            // navigation: {
            //     nextEl: '.swiper--hero-button-next',
            //     prevEl: '.swiper--hero-button-prev',
            //     addIcons: false,
            // },
            watchSlidesProgress: true,
            thumbs: {
                swiper: modalProductThumbsSwiper,
            },
        });

    };

    const initTeamsSlider = () => {
        const featuresSwiper = new Swiper('.swiper--teams', {
            modules: [ Navigation, Pagination ],
            pagination: {
                el: '.swiper--teams-pagination',
                clickable: true,
                dynamicBullets: true,
            },
            navigation: {
                nextEl: '.swiper--teams-button-next',
                prevEl: '.swiper--teams-button-prev',
            },
            watchOverflow: true,
            slidesPerView: 1,
            spaceBetween: 16,
            simulateTouch: false,
            breakpoints: {
                640: {
                    slidesPerView: 2,
                    slidesPerGroup: 2,
                    spaceBetween: 16,
                    // freeMode: true,
                    pagination: {
                        el: '.swiper--teams-pagination',
                        clickable: true,
                        dynamicBullets: true,
                    },
                },
                1024: {
                    slidesPerView: 3,
                    slidesPerGroup: 3,
                    spaceBetween: 24,
                    pagination: {
                        el: '.swiper--teams-pagination',
                        clickable: true,
                        dynamicBullets: false,
                    },
                },
                1280: {
                    slidesPerView: 4,
                    spaceBetween: 0,
                    slidesPerGroup: 4,
                    pagination: {
                        el: '.swiper--teams-pagination',
                        clickable: true,
                        dynamicBullets: false,
                    },
                },
            },
        });
        // return filmsSwiper;
    };

    const initHistorySlider = () => {

        const swiperHistoryThumbs = new Swiper('.swiper--history-thumbs', {
            modules: [ Navigation ],
            navigation: {
                nextEl: '.swiper--history-thumbs-button-next',
                prevEl: '.swiper--history-thumbs-button-prev',
            },
            // simulateTouch: false,
            spaceBetween: 24,
            slidesPerView: 1,
            // centeredSlides: true,
            watchSlidesProgress: true,
            slideToClickedSlide: true,

            on: {
                slideChange(swiper) {
                    swiperHistory.slideTo(swiper.activeIndex);
                }
            },
            breakpoints: {
                480: {
                    spaceBetween: 24,
                    slidesPerView: 3,
                    centeredSlides: true,
                },
                768: {
                    spaceBetween: 24,
                    slidesPerView: 3,
                    centeredSlides: true,
                },
                1024: {
                    spaceBetween: 24,
                    slidesPerView: 5,
                    centeredSlides: true,
                },
                // 1280: {
                //     slidesPerView: 4,
                //     spaceBetween: 0,
                //     slidesPerGroup: 4,
                //     pagination: {
                //         el: '.swiper--articles-pagination',
                //         clickable: true,
                //         dynamicBullets: false,
                //     },
                // },
            },
        });

        const swiperHistory = new Swiper('.swiper--history', {
            modules: [ Navigation, EffectFade, Thumbs ],
            watchOverflow: true,
            slidesPerView: 1,
            spaceBetween: 0,

            autoHeight: true,
            navigation: {
                nextEl: '.swiper--history-button-next',
                prevEl: '.swiper--history-button-prev',
                addIcons: false,
            },
            watchSlidesProgress: true,
            thumbs: {
                swiper: swiperHistoryThumbs,
            },
            // loop: true,
            // autoplay: {
            //     delay: 5000,
            //     disableOnInteraction: false
            // },
            on: {
                slideChange(swiper) {
                    const thumbs = swiper.thumbs.swiper;
                    if (thumbs) thumbs.slideTo(swiper.activeIndex);
                    console.log('activeIndex', swiper.activeIndex);
                }
            },
            breakpoints: {
                768: {
                    effect: "fade",
                    speed: 600,
                },
                // 1024: {
                //     slidesPerView: 3,
                //     slidesPerGroup: 3,
                //     spaceBetween: 24,
                //     pagination: {
                //         el: '.swiper--articles-pagination',
                //         clickable: true,
                //         dynamicBullets: false,
                //     },
                // },
                // 1280: {
                //     slidesPerView: 4,
                //     spaceBetween: 0,
                //     slidesPerGroup: 4,
                //     pagination: {
                //         el: '.swiper--articles-pagination',
                //         clickable: true,
                //         dynamicBullets: false,
                //     },
                // },
            },

        });

    };

    return {
        initHeroSlider,
        initFeaturesSlider,
        initHomeProductsSlider,
        initArticlesSlider,
        initPhotosSlider,
        initVideosSlider,
        initTestimonialsSlider,
        initModalProductSlider,
        initTeamsSlider,
        initHistorySlider
    };
};

export default initSliders;
